module.exports = __webpack_public_path__ + "img/2.4b44a424.png";